import BasicECharts from 'components/common/BasicEChart';
import { BarChart } from 'echarts/charts';
import {
  GridComponent,
  LegendComponent,
  TitleComponent,
  TooltipComponent
} from 'echarts/components';
import * as echarts from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers';
import _ from 'lodash';
import React from 'react';
import { Spinner } from 'react-bootstrap';
import { getDashboardBarOptions } from '../dashboardChartOptions';

echarts.use([
  TitleComponent,
  TooltipComponent,
  GridComponent,
  BarChart,
  CanvasRenderer,
  LegendComponent
]);

const SessionByUsesChart = ({
  data,
  labelPrefix,
  xAxisLabel = 'Category',
  yAxisLabel = 'Value'
}) => {
  const values = _.map(data, item => Number(item.value) || 0);
  const labels = _.map(data, 'label');
  const colors = _.map(data, 'color');

  return (
    <>
      {data ? (
        <BasicECharts
          echarts={echarts}
          options={getDashboardBarOptions({
            colors,
            data: values,
            keys: labels,
            xAxisLabel,
            yAxisLabel,
            valuePrefix: labelPrefix,
            compactYAxisLabels: labelPrefix === '$'
          })}
          style={{ height: 285 }}
        />
      ) : (
        <Spinner />
      )}
    </>
  );
};

export default SessionByUsesChart;
